module.exports = __webpack_public_path__ + "img/5a398dd.jpg";